import { Grid } from "@mui/material";
import React, { useState } from "react";
import {
    DragDropContext,
    DragStart,
    DropResult,
    ResponderProvided
} from "react-beautiful-dnd";
import { ISessionState } from "source/models/session/sessionState";
import { ITaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { ITaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { GridRow } from "../../../framework/Grid/GridRow";
import { ITaskTypeChart } from "ui/Scripts/source/models/task/taskTypeChart";
import { ChartDesignerChartPicker } from "./ChartDesignerChartPicker";
import { ChartDesignerBuilder } from "./ChartDesignerBuilder";
import { ITaskTypeChartPropUpdate, TaskTypeDialogChartDesignerDroppableId } from "../FormDesignerTypes";
import { AppChartType } from "ui/Scripts/source/models/enums";
import { ChartDesignerChartProperties } from "./ChartDesignerChartProperties";

interface ITaskTypeDialogChartDesignerProps {
    sessionState: ISessionState;
    taskType: ITaskEditTypeItem;
    selectedTaskTypeChart: ITaskTypeChart;
    chartTestDataRows: ITaskDataRow[];
    onChartSchemaAddItem: (taskChartType: AppChartType, index: number) => void;
    onChartSchemaMoveItem: (name: string, index: number) => void;
    onChartClick: (name: string) => void;
    onRemoveChart: (name: string) => void;
    onCopyChart: (name: string) => void;
    onChartPropUpdate: (values: ITaskTypeChartPropUpdate[]) => void;
    onChartTestDataRowsChange: (chartTestDataRows: ITaskDataRow[]) => void;
}

interface ITaskTypeDialogFormDesignerState {
    dragging?: {
        source?: string;
    },
}

export const TaskTypeDialogChartDesigner = (props: ITaskTypeDialogChartDesignerProps) => {
    const [state, setState] = useState<ITaskTypeDialogFormDesignerState>();

    const handleDragEnd = (result: DropResult, provided: ResponderProvided) => {
        //console.log("handleDragEnd S", result?.destination, result?.source, `'${result?.draggableId}'`);
        if (!result?.destination) return;
        if (result?.source?.droppableId === TaskTypeDialogChartDesignerDroppableId.Picker) {
            setTimeout(() => {
                if ((result?.destination.droppableId ?? "").startsWith(TaskTypeDialogChartDesignerDroppableId.Design)) {
                    props.onChartSchemaAddItem(result.draggableId.toInteger(), result.destination.index);
                }
            }, 10);
        } else if ((result?.source?.droppableId ?? "").startsWith(TaskTypeDialogChartDesignerDroppableId.Design)) {
            const chartId = result.draggableId?.substring(TaskTypeDialogChartDesignerDroppableId.Design.length) ?? "";
            props.onChartSchemaMoveItem(chartId, result.destination.index);
        }
        setState((old) => ({
            ...old,
            dragging: null,
        }));
    };

    const handleDragStart = (initial: DragStart) => {
        //console.log("handleDragStart S", initial, initial.source, initial.source?.droppableId, initial.draggableId, props.taskType);
        if (!initial.source || !initial.draggableId) return;
        const droppableId = initial.source.droppableId;
        setState((old) => ({
            ...old,
            dragging: {
                source: droppableId,
            },
        }));
    };

    return (
        <GridRow sx={{ flexGrow: 1 }}>
            <DragDropContext
                onDragEnd={handleDragEnd}
                onDragStart={handleDragStart}
            >
                <Grid item sm={3}>
                    <ChartDesignerChartPicker />
                </Grid>
                <Grid item sm={6}>
                    <ChartDesignerBuilder
                        draggingSource={state?.dragging?.source}
                        taskType={props.taskType}
                        selectedTaskTypeChart={props.selectedTaskTypeChart}
                        chartTestDataRows={props.chartTestDataRows}
                        onChartClick={props.onChartClick}
                        onRemoveChart={props.onRemoveChart}
                        onCopyChart={props.onCopyChart}
                    />
                </Grid>
                <Grid item sm={3}>
                    <ChartDesignerChartProperties
                        sessionState={props.sessionState}
                        taskType={props.taskType}
                        selectedTaskTypeChart={props.selectedTaskTypeChart}
                        chartTestDataRows={props.chartTestDataRows}
                        onChartClick={props.onChartClick}
                        onChartPropUpdate={props.onChartPropUpdate}
                        onFormDataRowsChange={props.onChartTestDataRowsChange}
                    />
                </Grid>
            </DragDropContext>
        </GridRow>
    );
};
